import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { FormBuilder, Validators } from '@angular/forms';
import { RedirectSkill } from '../../../../../store/samwin/samwin-skills/samwin-skills.actions';
import { SamwinSkillsState } from '../../../../../store/samwin/samwin-skills/samwin-skills.state';
import { BehaviorSubject, combineLatest, Observable, Subject } from 'rxjs';
import { SkillDiversionTargetRemoteDto } from '../../../../../../generated/signalR/skill-diversion-target-remote-dto';
import _ from 'lodash';
import { map } from 'rxjs/operators';
import { faArrowAltFromLeft, IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { TextBoxComponent } from '@progress/kendo-angular-inputs';
import { Skill } from '../../../../../store/samwin/samwin-skills/skill';

@Component({
   selector: 'samweb-skill-diversion-dialog',
   templateUrl: './skill-diversion-dialog.component.html',
   styleUrls: ['./skill-diversion-dialog.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkillDiversionDialogComponent implements OnInit {
   constructor(private store: Store, private formBuilder: FormBuilder) {}

   @ViewChild('inputElement')
   private inputElement: ComboBoxComponent | TextBoxComponent;

   public redirectionIcon: IconDefinition = faArrowAltFromLeft;

   @Output()
   public skillDiversionDialogFinished = new EventEmitter();

   @Input()
   public skills: Skill[];

   @Input()
   public brickInstanceId: string;

   @Select(SamwinSkillsState.getPermittedSkillDiversions)
   public permittedSkillDiversions$: Observable<SkillDiversionTargetRemoteDto[]>;

   public filteredSkillDiversions$: Observable<SkillDiversionTargetRemoteDto[]>;

   public userFilter$: Subject<string> = new BehaviorSubject<string>('');

   public formGroup = this.formBuilder.group({
      diversionTarget: ['', [Validators.required]],
   });

   ngOnInit() {
      this.filteredSkillDiversions$ = combineLatest([this.permittedSkillDiversions$, this.userFilter$]).pipe(
         map(([skills, filter]) => {
            const searchFilterLower = filter.toLowerCase();
            return _.chain(skills)
               .filter((x) => {
                  return x.name.toLowerCase().indexOf(searchFilterLower) > -1 || x.number.toLowerCase().indexOf(searchFilterLower) > -1;
               })
               .value();
         })
      );
      setTimeout(() => {
         this.inputElement.focus();
      }, 0);
   }

   activateSkillRedirection() {
      if (!this.formGroup.valid) {
         console.log('Form isn`t valid');
         return;
      }
      console.log(`ActivateDiversionForSkill ${this.skills}, ${this.formGroup.value.diversionTarget}`);
      this.skills.forEach((skill) => {
         if (this.store.selectSnapshot(SamwinSkillsState.getIsSkillDiversionAllowedForSkill(skill.skillId))) {
            this.store.dispatch(new RedirectSkill(skill.skillId, this.formGroup.value.diversionTarget, this.brickInstanceId));
         }
      });
      this.skillDiversionDialogFinished.emit();
   }

   userFilterChanged(value: string) {
      this.userFilter$.next(value);
   }
}
